module.exports = __webpack_public_path__ + "static/media/sidebar-2.62eb038a.jpg";